import { useConvexAuth, useQuery } from "convex/react";
import { Navigate, Outlet } from "react-router";
import { useAuthActions } from "@convex-dev/auth/react";
import { api } from "@convex/_generated/api";
import { AdminNavbar } from "./AdminNavbar";
import { Footer } from "@repo/ui";

export function SuperAdminGuard() {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const profile = useQuery(api.users.currentUserProfile);
  const { signOut } = useAuthActions();

  if (isLoading || (isAuthenticated && profile === undefined)) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!profile?.isAdmin) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-background px-4">
        <div className="max-w-md rounded-surface border bg-card p-8 text-center shadow-sm">
          <h2 className="text-xl font-semibold text-foreground mb-2">Accès non autorisé</h2>
          <p className="text-sm text-muted-foreground mb-4">
            Cette interface est réservée aux super-administrateurs.
          </p>
          <button
            onClick={() => signOut()}
            className="text-sm font-medium text-primary hover:underline"
          >
            Retour à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen w-full flex-col">
      <AdminNavbar />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
